import {
    getRefreshToken,
    saveTokens,
    isAccessTokenExpired,
    isRefreshTokenExpired,
    resetTokens,
    getAccessToken
} from '~/account/utilities/helpers';

const removeSlashesRegex = '/^\\/+|\\/+$/';

const buildRefreshUrl = () => {
    const baseUrl = process.env.GATSBY_CMS_BASE_URL.replace(
        removeSlashesRegex,
        ''
    );
    const apiBase = process.env.GATSBY_CMS_AMP_API_BASE.replace(
        removeSlashesRegex,
        ''
    );
    return `${baseUrl}/${apiBase}/api/auth/token/refresh`;
};

let refreshPromise = null;

export const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();

    if (!refreshToken) {
        return null;
    }

    if (isRefreshTokenExpired()) {
        resetTokens();
        return null;
    }

    const response = await fetch(buildRefreshUrl(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ refresh: refreshToken })
    });

    if (!response.ok) {
        resetTokens();
        return null;
    }

    const data = await response.json();

    if (data.access) {
        saveTokens({ access: data.access, refresh: data.refresh });
        return data.access;
    }

    return null;
};

export const ensureValidToken = async () => {
    const accessToken = getAccessToken();

    if (accessToken && !isAccessTokenExpired()) {
        return accessToken;
    }

    if (!getRefreshToken() || isRefreshTokenExpired()) {
        resetTokens();
        return null;
    }

    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = refreshAccessToken().finally(() => {
        refreshPromise = null;
    });

    return refreshPromise;
};
